module.exports = __webpack_public_path__ + "static/media/Books.80f972de.md";